import React, { useEffect , Suspense, lazy  } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

//const Home = lazy(() => import('./components/mainpage/pages/Home'));

//import Home from './components/mainpage/pages/Home';
const Home = lazy(() => import('./components/mainpage/pages/Home'));



const App = () => {
    useEffect(() => {
        // Check if we're on a secure connection (HTTPS)
        const isSecure = window.location.protocol === "https:";
        
        if (isSecure) {
          // Production - use partitioned cookie
          document.cookie = "__Host-name=value; Secure; Path=/; SameSite=None; Partitioned;";
          //console.log("Production cookie set");
        } else {
          // Development - use simpler cookie
          document.cookie = "name=value; Path=/; SameSite=Lax;";
          //console.log("Development cookie set");
        }
        
        /*setTimeout(() => {
          console.log("Current cookies:", document.cookie);
        }, 100);*/
    }, []);

    return (
        <>
            <Router>
                <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path='/' element={<Home />} />
                
                </Routes>
                </Suspense>
            </Router>

        </>
       
    )
}

export default App;